import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';

const showFallback = (title: string, message: string, refresh: boolean) => {
  const container = document.getElementById('root');
  if (!container) return;
  const template = document.getElementById('bs-fallback') as HTMLTemplateElement | null;
  if (!template) {
    container.textContent = message;
    return;
  }
  container.replaceChildren(template.content.cloneNode(true));
  container.querySelector('[data-title]')!.textContent = title;
  container.querySelector('[data-message]')!.textContent = message;
  (container.querySelector('[data-refresh]') as HTMLButtonElement).hidden = !refresh;
};

if (window.location.pathname === '/auth/microsoft') {
  localStorage.setItem('bs-sign-in-callback', String(Date.now()));
  import('@azure/msal-browser/redirect-bridge')
    .then(({ broadcastResponseToMainFrame }) => broadcastResponseToMainFrame())
    .catch((error: unknown) => {
      console.error('Microsoft sign-in callback failed', error);
      showFallback('Signal lost', 'Microsoft sign-in could not finish. Close this window and try again.', false);
    });
} else {
  import('./App')
    .then(({ default: App }) => {
      const root = ReactDOM.createRoot(document.getElementById('root') as HTMLElement);
      root.render(<App />);
    })
    .catch((error: unknown) => {
      console.error('Application initialization failed', error);
      showFallback('The keeper is changing the bulb', 'Beacon Suite will be shining again in a moment. Please refresh the page.', true);
    });
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
